import React from 'react';
import TrophySvg from './TrophySvg';

/* ====================================================================
   PENDING REGS MODAL — Global modal showing all pending registrations
   ==================================================================== */
function PendingRegsModal({ API, authToken, onClose, onRegChange, onOpenComp }) {
  const [regs, setRegs] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [processing, setProcessing] = React.useState(null);

  const loadRegs = React.useCallback(() => {
    fetch(`${API}/api/registrations/pending-all`, { headers: { Authorization: `Bearer ${authToken}` } })
      .then(r => r.ok ? r.json() : []).then(setRegs).catch(() => {}).finally(() => setLoading(false));
  }, [API, authToken]);

  React.useEffect(() => { loadRegs(); }, [loadRegs]);

  const handleStatus = async (compId, regId, status) => {
    setProcessing(regId);
    try {
      const r = await fetch(`${API}/api/registrations/${compId}/${regId}`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authToken}` },
        body: JSON.stringify({ status }),
      });
      if (r.ok) {
        loadRegs();
        if (onRegChange) onRegChange();
      }
    } catch {}
    setProcessing(null);
  };

  // Group by competition
  const grouped = {};
  regs.forEach(reg => {
    const compId = reg.Competition ? reg.Competition.id : 'unknown';
    const compName = reg.Competition ? reg.Competition.name : 'Unknown Competition';
    if (!grouped[compId]) grouped[compId] = { name: compName, regs: [] };
    grouped[compId].regs.push(reg);
  });

  return (
    <div className="w3-modal" style={{ display: 'block' }}>
      <div className="w3-modal-content w3-card-4 w3-round" style={{ maxWidth: '600px', margin: '60px auto' }}>
        <div className="w3-container w3-theme-d2 w3-round-top" style={{ padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontWeight: 700, fontSize: '1.05em' }}>
            <i className="fa fa-bell w3-margin-right" style={{ color: '#ff9800' }}></i>
            Pending Registrations ({regs.length})
          </span>
          <button className="w3-button w3-round w3-tiny w3-hover-red" onClick={onClose}><i className="fa fa-times"></i></button>
        </div>

        <div style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
          {loading && (
            <div className="w3-center w3-padding"><i className="fa fa-spinner fa-spin"></i> Loading...</div>
          )}

          {!loading && regs.length === 0 && (
            <div className="w3-center w3-padding w3-text-grey"><em>No pending registrations</em></div>
          )}

          {Object.entries(grouped).map(([compId, group]) => (
            <div key={compId} style={{ borderBottom: '1px solid #eee' }}>
              <div className="w3-container w3-theme-l4" style={{ padding: '8px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontWeight: 600, fontSize: 'var(--gs-text-sm)' }}>
                  <TrophySvg size={14} style={{ marginRight: '8px' }} />{group.name}
                </span>
                <button className="w3-button w3-round w3-tiny w3-theme-l2" onClick={() => onOpenComp(Number(compId))}>
                  Open <i className="fa fa-arrow-right w3-margin-left"></i>
                </button>
              </div>
              {group.regs.map(reg => (
                <div key={reg.id} className="w3-container" style={{ padding: '8px 16px', borderTop: '1px solid #f0f0f0' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px' }}>
                    <div style={{ flex: 1, minWidth: '150px' }}>
                      <strong>{reg.User ? reg.User.name : 'Unknown'}</strong>
                      {reg.User && reg.User.email && <span className="w3-text-grey w3-small"> — {reg.User.email}</span>}
                      {(reg.Team || reg.teamName) && (
                        <span className="w3-tag w3-round w3-theme-l3 w3-small" style={{ marginLeft: '8px', padding: '1px 8px', fontSize: 'var(--gs-text-xs)' }}>
                          Team: {reg.Team ? reg.Team.name : reg.teamName}
                        </span>
                      )}
                      {reg.Team && reg.Team.Users && reg.Team.Users.length > 0 && (
                        <div className="w3-tiny w3-text-grey" style={{ marginTop: '2px' }}>
                          Members: {reg.Team.Users.map(u => u.name).join(', ')}
                        </div>
                      )}
                      <div className="w3-tiny w3-text-grey">
                        <i className="fa fa-clock-o w3-margin-right"></i>
                        {new Date(reg.createdAt).toLocaleDateString()} {new Date(reg.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '6px' }}>
                      <button className="w3-button w3-round w3-small w3-green"
                        disabled={processing === reg.id}
                        onClick={() => handleStatus(reg.CompetitionId, reg.id, 'approved')}>
                        {processing === reg.id ? <i className="fa fa-spinner fa-spin"></i> : <><i className="fa fa-check w3-margin-right"></i>Approve</>}
                      </button>
                      <button className="w3-button w3-round w3-small w3-red"
                        disabled={processing === reg.id}
                        onClick={() => handleStatus(reg.CompetitionId, reg.id, 'rejected')}>
                        <i className="fa fa-times"></i>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PendingRegsModal;
